import Select from "components/common/Select";
import actions from "components/global/logic/actions";
import { assertArray } from "core/validation";
import PropTypes from "prop-types"; 
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { API_URL } from "services/index";
export function FilmRatingTypes({ value, onChange, types, onLoadTypes, placeholder }) {
    useEffect(() => {
        if (!assertArray(types)) {
            onLoadTypes();
        }
    }, [onLoadTypes, types]);
    const options = types.map((t) => ({ ...t, value: t.id, label: t.name }));
    return <Select placeholder={placeholder || "Rating"} value={value} onChange={onChange} options={options} />;
}

FilmRatingTypes.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.number,
    types: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
        })
    ),
    onLoadTypes: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
};

export default connect(
    ({ globalApp }) => ({
        types: globalApp.filmRatingTypes,
    }),
    (dispatch) => ({
        onLoadTypes: () => dispatch(actions.APP_GET_FILM_RATING_TYPE.send(API_URL.filmRatingT())),
    })
)(FilmRatingTypes);
